import createReducer from '../createReducer';

const initialState = {
    tickets: [],
    searchTickets: [],
    isSearchState:false,
    currentTicket: null,
    groups: [],
    ticketsIcon:null,
    isAcceptedAll:false,
    
    addTicketXHR:null,
    addTicketFullXHR:null,
    updateTicketXHR:null,
    updateTicketFullXHR:null,
    getEventTicketsXHR:null,
    getEventGroupsXHR:null,
    updateGroupXHR:null,
    updateGroupFullXHR:null,
    addGroupXHR:null,
    addGroupFullXHR:null,
    deleteGroupXHR:null,
    duplicateTicketXHR:null,
    sendTicketXHR:null,
};

const reducer = createReducer('tickets', initialState);

export default reducer;
